import { ERROR_MSGS } from '../../constants/registration/error.messages';
import { ErrorHandlerOptions } from '../error.interface';
import { ErrorCodes } from './errorCodes';

interface E400 extends ErrorHandlerOptions {}

export const handle400Error = ({ error, showError, action }: E400) => {
  const errorCode = error?.data?.code;

  switch (errorCode) {
    case ErrorCodes.EMAIL_ALREADY_EXISTS:
      showError?.(ERROR_MSGS.INVITATION_TOKEN_NOT_FOUND);
      action?.(error);
      break;
    default:
      showError?.(ERROR_MSGS.UNKNOWN_ERROR);
      break;
  }
};
